export default "__VITE_ASSET__B6wWW5tu__"